import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import { Component } from "react";
import JSONInput from "react-json-editor-ajrm";
import { connect } from "react-redux";

import DataTable from "../../components/api-connect/TableDataExtensions";
import { mapActionsExtensionToProps } from "../../redux/api-connect/extension";
class Extension extends Component {
  state = {
    dialog: false,
  };
  componentDidMount() {
    this.props.extension && this.props.getExtensionApiConnectAction();
  }

  render() {
    const {
      extension: { items },
    } = this.props;
    const result =
      typeof items === "object"
        ? Object.keys(items).map((key) => items[key])
        : items;
    return (
      <div>
        <DataTable
          extensions={result}
          viewExtension={() => this.setState({ dialog: true })}
        />
        <Dialog
          open={this.state.dialog}
          onClose={() => this.setState({ dialog: false })}
          fullWidth={true}>
          <DialogTitle>Extension</DialogTitle>
          <DialogContent>
            <JSONInput
              style={{
                outerBox: {
                  width: "100%",
                },
                container: {
                  width: "100%",
                },
              }}
              placeholder={result}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ dialog: false })}>
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  extension: state.apiConnectExtension.extensions,
});

export default connect(mapStateToProps, mapActionsExtensionToProps)(Extension);
